import { initialize } from "./startup";

initialize();
